import { PaginatedDataDTO } from "@bottega52/commons-pagination";
import { AppBar, Button, Card, IconButton, Tab, Tabs } from "@material-ui/core";
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { Edit } from "@material-ui/icons";
import WalletIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import DomainsIcon from '@material-ui/icons/Domain';
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import UserIcon from '@material-ui/icons/PersonOutline';
import VisibilityIcon from '@material-ui/icons/Visibility';
import WarningIcon from '@material-ui/icons/Warning';
import * as React from "react";
import { connect, ConnectedProps } from "react-redux";
import { ModalTypes } from '../../components/Modals/ModalTypes';
import * as ActivationActions from '../../redux/activations/activations.actions';
import * as CreditsActions from '../../redux/credits/credits.actions';
import * as ModalsActions from '../../redux/modals/modals.actions';
import * as SettingsActions from '../../redux/settings/settings.actions';
import { IState } from "../../redux/store";
import * as UserActions from '../../redux/user/user.actions';
import { IVarInDTO } from "../../repository/jago/model/input/IVarInDTO";
import { IWalletDetailedDTO } from "../../repository/jago/model/input/IWalletDetailedDTO";
import { IWalletFormDTO } from "../../repository/jago/model/input/IWalletFormDTO";
import { IWalletInDTO } from "../../repository/jago/model/input/IWalletInDTO";
import { IOrderDirectionEnum } from "../../repository/jago/model/output/RequestParamsDTOs";
import AbilityProvider from '../../services/PermissionService/AbilityProvider';
import { PERMISSIONS } from '../../services/PermissionService/PermissionConstants';
import { RED } from "../../style/StyleConsts";
import { VAR_USERS_ROLES } from "../../utils/Utils";
import CustomerContractIconCustom from "../CustomerContractIconCustom";
import WalletForm from "../Forms/WalletForm";
import Permission from "../Permission/Permission";
import ReduxLanguage from "../ReduxLanguage";
import WalletDetailsPage from "../Wallets/WalletDetailsPage";
import CustomerContractsSection from "./CustomerContractsSection";
import CustomerOpportunitySection from "./CustomerOpportunitySection";
import CustomerPlantsSection from "./CustomerPlantsSection";
import CustomerWalletSection from "./CustomerWalletSection";

const styles = createStyles({
  container: {
    display: 'flex',
    margin: 10,
    flexDirection: 'column',
    paddingBottom: 50,
  },
  headerContainer: {
    marginTop: 20,
    padding: 10,
    borderLeft: '3px solid #0D47A1',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerInner: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  icon: {
    marginRight: 5,
    fontSize: 25,
  },
  title: {
    fontWeight: 'bold'
  },
});

type IReduxProps = ConnectedProps<typeof connector>;

export interface ICustomerDetailsViewProps extends WithStyles<typeof styles>{
  onEditCustomerData: () => void;
  onSeeCustomerDetails: () => void;
  onVarClick: (varId: number) => void;
  hideEditCustomer?: boolean;
  hideDeleteCustomer?: boolean;
  hideShowCustomerDetails?: boolean;
  onDeleteCustomerRequest?: () => void;
}

export type ComponentProps = ICustomerDetailsViewProps & IReduxProps;
class CustomerDetailsView extends React.Component<ComponentProps, any> {

  constructor(props: ComponentProps) {
    super(props);
    const isSimplifiedCustomer = props.selectedCustomer && !props.selectedCustomer.vat;
    this.state = {
      activeTab: isSimplifiedCustomer ? 1 : 0,
    }
  }

  editWallet(wallet: IWalletDetailedDTO) {
    this.onOpenWalletForm(wallet);
  }

  async onSelectWallet(wallet: IWalletInDTO) {
    const { dispatch } = this.props;
    await dispatch<any>(CreditsActions.setSelecteWallet(wallet));
    await dispatch<any>(CreditsActions.fetchWalletInfo({ walletId: wallet.id }));
    await dispatch<any>(CreditsActions.fetchCustomerWalletSubscriptions({ walletId: wallet.id, page: 0, pageSize: 200 }));
    await dispatch<any>(CreditsActions.fetchCustomerWalletCredits({ walletId: wallet.id, page: 0, orderDir: IOrderDirectionEnum.DESC, pageSize: 50 }));
    await dispatch<any>(CreditsActions.fetchCustomerWalletPlants({ walletId: wallet.id, page: 0, pageSize: 50 }));
    await dispatch<any>(CreditsActions.fetchCustomerWalletUsage({ walletId: wallet.id, page: 0, orderDir: IOrderDirectionEnum.DESC, pageSize: 50 }));
    await dispatch<any>(CreditsActions.fetchCustomerWalletAvailableCredits(wallet.id));
  }

  public onCreateNewWalletRequest(walletData: IWalletFormDTO) {
    const { dispatch } = this.props;
    dispatch<any>(ModalsActions.showModal(`CREATE_CUSTOMER_WALLET_CONFIRM_MODAL`, {
      modalType: ModalTypes.CONFIRM_MODAL,
      modalProps: {
        icon: <WarningIcon style={{ color: 'orange', fontSize: 50 }} />,
        titleMessageKey: 'credits.newWallet',
        successMessageKey: 'credits.walletCreationConfirm',
        confirmMessageKey: 'credits.createWallet',
        cancelMessageKey: 'forms.cancel',
        onConfirm: () => this.onCreateNewWalletConfirm(walletData),
        onCancel: () => dispatch<any>(ModalsActions.hideModal(`CREATE_CUSTOMER_WALLET_CONFIRM_MODAL`)),
      }
    }));
  }

  public async onCreateNewWalletConfirm(walletData: IWalletFormDTO) {
    const { dispatch, selectedCustomer } = this.props;
    try {
      dispatch<any>(ModalsActions.hideModal(`CREATE_CUSTOMER_WALLET_CONFIRM_MODAL`));
      dispatch<any>(SettingsActions.setSpinnerVisible(true));
      await dispatch<any>(CreditsActions.createNewCustomerWallet(selectedCustomer.id, walletData));
      dispatch<any>(ModalsActions.hideModal('OPERATIONAL_WALLET_FORM_MODAL'));
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_WALLET_CREATION`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'errors.createCustomerWalletError',
        }
      }));
    }
  }

  public editWalletRequest(walletId: number, walletData: IWalletFormDTO) {
    const { dispatch } = this.props;
    dispatch<any>(ModalsActions.showModal(`EDIT_CUSTOMER_WALLET_CONFIRM_MODAL`, {
      modalType: ModalTypes.CONFIRM_MODAL,
      modalProps: {
        icon: <WarningIcon style={{ color: 'orange', fontSize: 50 }} />,
        titleMessageKey: 'credits.editWallet',
        successMessageKey: 'credits.walletEditConfirm',
        confirmMessageKey: 'credits.editWallet',
        cancelMessageKey: 'forms.cancel',
        onConfirm: () => this.editWalletConfirm(walletId, walletData),
        onCancel: () => dispatch<any>(ModalsActions.hideModal(`EDIT_CUSTOMER_WALLET_CONFIRM_MODAL`)),
      }
    }));
  }

  async editWalletConfirm(walletId: number, walletData: IWalletFormDTO) {
    const { dispatch } = this.props;
    try {
      dispatch<any>(ModalsActions.hideModal(`EDIT_CUSTOMER_WALLET_CONFIRM_MODAL`));
      dispatch<any>(SettingsActions.setSpinnerVisible(true));
      const walletUpdated = await dispatch<any>(CreditsActions.editCustomerWallet(walletId, walletData));
      await this.onSelectWallet(walletUpdated)
      dispatch<any>(ModalsActions.hideModal('OPERATIONAL_WALLET_FORM_MODAL'));
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_WALLET_CREATION`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'errors.editCustomerWalletError',
        }
      }));
    }
  }

  public onDeleteWalletRequest(wallet: IWalletDetailedDTO) {
    const { dispatch } = this.props;
    dispatch<any>(ModalsActions.showModal(`DELETE_WALLET_CONFIRM_MODAL`, {
      modalType: ModalTypes.CONFIRM_MODAL,
      modalProps: {
        icon: <WarningIcon style={{ color: 'orange', fontSize: 50 }} />,
        titleMessageKey: 'domains.walletDeletionTitle',
        successMessageKey: 'domains.walletDeletionConfirm',
        confirmMessageKey: 'domains.sendDeletionRequest',
        cancelMessageKey: 'forms.cancel',
        onConfirm: () => this.onDeleteWalletConfirm(wallet),
        onCancel: () => dispatch<any>(ModalsActions.hideModal(`DELETE_WALLET_CONFIRM_MODAL`)),
      }
    }));
  }

  public async onDeleteWalletConfirm(wallet: IWalletDetailedDTO) {
    const { dispatch } = this.props;
    try {
      const walletName = wallet.name
      const walletId = wallet.id
      dispatch<any>(ModalsActions.hideModal(`DELETE_WALLET_CONFIRM_MODAL`));
      dispatch<any>(SettingsActions.setSpinnerVisible(true));
      await dispatch<any>(UserActions.openCloseWalletTicket(walletId,walletName));
      dispatch<any>(ModalsActions.hideModal('OPERATIONAL_DOMAIN_MODAL'));
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`SUCCESS_MODAL`, {
        modalType: ModalTypes.SUCCESS_MODAL,
        modalProps: {
          titleMessageKey: 'domains.walletDeletionSuccess',
        }
      }));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_WALLET_DELETION`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'errors.deleteWalletRequestError',
        }
      }));
    }
  }

  public async onOpenWalletForm(wallet?: IWalletDetailedDTO) {
    const { dispatch } = this.props;
    try {
      await dispatch<any>(ActivationActions.fetchKams({ page: 0, pageSize: 500 }));
    } catch (error) {}
    dispatch<any>(ModalsActions.showModal(`OPERATIONAL_WALLET_FORM_MODAL`, {
      modalType: ModalTypes.OPERATIONAL_VIEW_MODAL_BACKDROP,
      modalProps: {
        content: (
          <WalletForm
            wallet={wallet}
            onCreateNewWallet={walletData => wallet ? this.editWalletRequest(wallet.id, walletData) : this.onCreateNewWalletRequest(walletData) }
          />
        ),
        titleMessageKey: 'forms.createNewWallet',
      }
    }));
  }

  public async onShowWalletDetails(wallet: IWalletInDTO) {
    const { dispatch } = this.props;
    try {
      dispatch<any>(SettingsActions.setSpinnerVisible(true));
      await this.onSelectWallet(wallet)
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`OPERATIONAL_DOMAIN_MODAL`, {
        modalType: ModalTypes.OPERATIONAL_VIEW_MODAL,
        modalProps: {
          onClose: () => dispatch<any>(CreditsActions.setSelecteWallet({})),
          overflowDisabled: true,
          content: (
            <WalletDetailsPage
              onEditWallet={(wallet) => this.editWallet(wallet)}
              onDeleteWalletRequest={(wallet) => this.onDeleteWalletRequest(wallet)}
            />
          ),
          titleMessageKey: 'credits.walletDetails',
        }
      }));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_WALLET_DETAILS`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'errors.getWalletDetailsError',
        }
      }));
    }
  }

  public render() {
    const { selectedCustomer, classes, onEditCustomerData, onDeleteCustomerRequest,
      vars, onVarClick, hideEditCustomer, hideShowCustomerDetails, onSeeCustomerDetails, hideDeleteCustomer } = this.props;
    const { activeTab } = this.state;
    const varsData = (vars as PaginatedDataDTO<IVarInDTO>)
    const isVar = AbilityProvider.getAbilityHelper().hasRoles(VAR_USERS_ROLES.map(e=>{return e.name}))
    const canOpenVarDetails = AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.NAVIGATION_VAR_MANAGEMENT);
    const isSimplifiedCustomer = selectedCustomer && !selectedCustomer.vat;
    return (
      <div className={classes.container}>
        <Card className={classes.headerContainer}>
          <div className={classes.header}>
            <div className={classes.headerInner}>
              <UserIcon className={classes.icon} />
              <div className={classes.headerTextContainer}>
                <div>
                  <h3 className={classes.title}>{selectedCustomer && selectedCustomer.name ? `${selectedCustomer.id} - ${selectedCustomer.name}` : ''}</h3>
                  <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.VAR_READ}>
                    {selectedCustomer && selectedCustomer.varId && varsData.content && varsData.content.filter(e=>e.id===selectedCustomer.varId).length > 0 ? (
                      <div style={{ marginLeft:0, cursor: canOpenVarDetails ? 'pointer': 'auto' }} onClick={canOpenVarDetails ? () => onVarClick(selectedCustomer.varId) : () => null}>
                        <h3 style={{ fontStyle: 'italic', fontWeight: 'bold', fontSize: '0.8em', display: 'inline', border: '1px solid grey', borderRadius: 5, marginRight: -2 }}>
                          {"VAR "}
                        </h3>
                        <h3
                          className={canOpenVarDetails ? "linkLabel" : ''}
                          style={{ fontSize: '0.8em', display: 'inline', marginLeft: -10, paddingLeft: 20, paddingRight: 5, color: canOpenVarDetails ? 'slateblue': '#3f3f3f' }}
                          onClick={canOpenVarDetails ? () => onVarClick(selectedCustomer.varId) : () => null}
                        >
                          {varsData.content.filter(e=>e.id === selectedCustomer.varId)[0].name}
                        </h3>
                      </div>
                    ) : null}
                  </Permission>
                </div>
                {!hideShowCustomerDetails ? (
                  <IconButton onClick={() => onSeeCustomerDetails()}>
                    <VisibilityIcon />
                  </IconButton>
                ) : null}
                {!hideEditCustomer ? (
                  <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.CUSTOMER_UPDATE}>
                    <IconButton onClick={() => onEditCustomerData()}>
                      <Edit />
                    </IconButton>
                  </Permission>
            ) : null}
              </div>
            </div>
            <span style={{ flexGrow: 1 }}></span>
            <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.CUSTOMER_DELETE_REQUEST}>
              {!hideDeleteCustomer ? (
                <Button
                  variant="contained"
                  style={{ backgroundColor: RED, fontSize: 11, fontWeight:'bold', color: 'white', marginRight: 20}}
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeleteCustomerRequest();
                  }}
                >
                  <ReduxLanguage languageKey="forms.deleteRequest" />
                </Button>
              ):null}
            </Permission>
          </div>
        </Card>
        <AppBar position="sticky" style={{ backgroundColor: 'white', marginTop: 20 }}>
          <Tabs
            value={activeTab}
            indicatorColor="primary"
            textColor="primary"
            style={{ backgroundColor: 'white', width: '100%' }}
            onChange={(e, index) => {this.setState({ activeTab: index })}}
          >
            {!isSimplifiedCustomer ? 
            (
              <Tab value={0} icon={<WalletIcon style={{ fontSize: 25 }} />} label={<h5 style={{ margin: 0 }}><ReduxLanguage languageKey="credits.wallets" /></h5>} />
            ) : null}
            {AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.CUSTOMER_PLANTS_READ) ? (
              <Tab value={1} icon={<DomainsIcon style={{ fontSize: 25 }} />} label={<h5 style={{ margin: 0 }}><ReduxLanguage languageKey="credits.customerPlants" /></h5>} />
            ) : null}
            {AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.CONTRACTS_READ) ? (
              <Tab value={2} icon={<CustomerContractIconCustom style={{ width: 25 }} />} label={<h5 style={{ margin: 0 }}><ReduxLanguage languageKey="credits.contracts" /></h5>} />
            ) : null}
            {isVar ? <Tab value={10} icon={<MonetizationOnOutlinedIcon style={{ fontSize: 25 }} />} label={<h5 style={{ margin: 0 }}><ReduxLanguage languageKey="vars.opportunities" /></h5>} /> : null}
          </Tabs>
        </AppBar>
        {activeTab === 0 ? (
          <CustomerWalletSection
            customer={selectedCustomer}
            onShowWalletDetails={(wallet) => this.onShowWalletDetails(wallet)}
            onOpenWalletForm={wallet => this.onOpenWalletForm(wallet)}
          />
        ):null}
        {activeTab === 1 ? (
          <CustomerPlantsSection
            customer={selectedCustomer}
            onShowWalletDetails={wallet => this.onShowWalletDetails(wallet)}
          />
        ):null}
        {activeTab === 2 ? (
          <CustomerContractsSection
            customer={selectedCustomer}
            onShowWalletDetails={wallet => this.onShowWalletDetails(wallet)}
          />
        ):null}
        {isVar && activeTab === 10 ? (
          <CustomerOpportunitySection
            customer={selectedCustomer}
          />
        ):null}
        
      </div>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    language: state.settings.language,
    selectedCustomer: state.credits.customers.selectedDetailedCustomer,
    vars: state.vars.vars.data,
    selectedCustomerPlant: state.credits.customerPlants.selectedCustomerPlant,
  };
}

const connector = connect(mapStateToProps);

export default connector(withStyles (styles)(CustomerDetailsView as any));